import { Location } from 'history';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

export const useAuthRedirect = () => {
  const history = useHistory();

  const redirectToLogin = useCallback(
    (from: Location) => {
      history.replace('/auth/login', { from });
    },
    [history]
  );

  const redirectToClientNotFound = useCallback(() => {
    history.replace('/clientNotFound');
  }, [history]);

  const redirectToHome = useCallback(() => {
    history.replace('/');
  }, [history]);

  return {
    redirectToLogin,
    redirectToClientNotFound,
    redirectToHome,
  } as const;
};
